<template>
  <div 
    :class="{ allbnw: blackAndWhite }"
    v-html="buildUpContent(detail)"
  ></div>
</template>

<script>
import Vue from "vue";
import ArticleInlineSlider from "./ArticleInlineSlider.vue";

export default {
  name: "article-content-render",
  props: {
    category: {
      type: String,
      default: "section",
    },
    slug: {
      type: String,
      default: "",
    },
    presetDetail: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    detail: function() {
      return this.slug
        ? this.$store.getters["article/getArticle"](
            this.category,
            this.slug,
            this.$i18n.locale,
          )
        : this.presetDetail;
    },
    tabParams: function() {
      if (this.$route.query.tab) {
        return this.$route.query.tab.split("|");
      }
      return [];
    },
  },
  data() {
    return {
      showContent: true,
      context: {},
      enjectScripts: [],
      tmpID: "UK",
      activeTabs: {},
    };
  },
  created() {
    this.tmpID = `${this.slug}.${this.category}.stylesheet.${
      this.$i18n.locale
    }`;

    if (this.$ssrContext) {
      this.injectStyles(this.detail, "", true);
    }

    console.log("article created");
  },
  beforeMount() {
    if (!document.getElementById(this.tmpID)) {
      this.injectStyles(this.detail, "", true);
    }
    console.log("article beforeMount");
  },
  mounted() {
    const vm = this;
    window.InlineSlider = {
      append: (containerSelector, images = [], activeIdx = 1) => {
        const containerEl = document.querySelector(containerSelector);
        if (containerEl) {
          if (getComputedStyle(containerEl).position === "static") {
            containerEl.style.setProperty("position", "relative");
          }
          const ArticleInlineSliderClass = Vue.extend(ArticleInlineSlider);
          const articleInlineSlider = new ArticleInlineSliderClass({
            propsData: {
              images,
              activeIdx,
            },
            parent: vm,
          });
          articleInlineSlider.$mount();
          containerEl.appendChild(articleInlineSlider.$el);
        }
      },
    };

    this.mockUpInternalLink();
    this.injectScripts(this.detail);
    console.log("article mounted");
  },
  beforeDestroy() {
    this.enjectStyles();
    this.runEnjectScripts();
    console.log("article beforeDestroy");
  },
  methods: {
    toID: function(raw) {
      return raw.toLowerCase().replace(/\s+/g, "-");
    },
    updateActiveTabs: function(tabs, ctr) {
      const activeTab = this.tabParams[ctr];
      if (typeof activeTab != "undefined") {
        this.activeTabs[ctr] = tabs.findIndex((tab) => {
          return tab.id == activeTab;
        });
        this.activeTabs[ctr] =
          this.activeTabs[ctr] == -1 ? 0 : this.activeTabs[ctr];
      } else {
        this.activeTabs[ctr] = 0;
      }
    },
    mockUpInternalLink: function() {
      let internalLinks = [].slice.call(
        document.querySelectorAll("a[data-internal-href]"),
      );
      internalLinks.forEach((link) => {
        let routingLink = link.dataset.internalHref;
        link.href = this.localedURL(routingLink);
        link.addEventListener("click", function(e) {
          e.preventDefault();
          window.AppRouter.push(routingLink);
        });
      });
    },
    isContentShow: function() {
      return this.showContent;
    },
    hideContent: function() {
      this.showContent = false;
    },
    activeContent: function() {
      this.showContent = true;
    },
    buildUpSection: function(section, ctr = 0) {
      let title = section.title
        ? `<div class="cx-div--outer">
          <h1 class="cx-t20 m-title"
          >${section.title}</h1>
        </div>`
        : "";

      return `
        <div class="m-sec cx-div">
          ${title}
          ${this.buildUpContent(section, ctr)}
        </div>
      `;
    },
    buildUpTab: function(tab, checked = false, ctr = 0) {
      const title = (tab && tab.title) || "";
      const id = this.toID(title);
      let queryParams = JSON.parse(JSON.stringify(this.$route.query));
      let params = {};
      let tabParams = JSON.parse(JSON.stringify(this.tabParams));
      tabParams[ctr] = tab.id;
      params["tab"] = tabParams.join("|");
      queryParams = JSON.stringify(Object.assign(queryParams, params)).replace(
        /"/g,
        "'",
      );
      return [
        `
        <input 
          type="radio" 
          name="grp" 
          id="${id}" 
          onClick="window.AppRouter.replace({ query: ${queryParams}})"
          ${checked ? 'checked="checked"' : ""}>
        <label
          for="${id}"
          role="tab"
          tabindex="0"
          onKeypress="event.key === 'Enter' || event.which === 13 ? this.click() : null"
          onKeydown="event.key === 'ArrowLeft' || event.which === 37 ? this.previousElementSibling?.previousElementSibling?.focus() : event.key === 'ArrowRight' || event.which === 39 ? this.nextElementSibling?.nextElementSibling?.focus() : null"
          aria-selected="${checked}"
          title="${tab.title}"
        >
          <span>${tab.title}</span>
        </label>
        `,
        `
        <article
          class="tab-content-article"
          style="display: ${checked ? "block" : "none"}"
        >
          ${this.buildUpContent(tab)}
        </article>
      `,
      ];
    },
    buildUpContent: function(article, ctr = 0) {
      if (typeof article != "object") return "";
      if (typeof article.content == "string") return article.content;

      if (Array.isArray(article.sections)) {
        return article.sections
          .map((section) => this.buildUpSection(section, ctr + 1))
          .join("");
      }

      if (Array.isArray(article.tabs)) {
        [].reduce(() => xxx, []);
        this.updateActiveTabs(article.tabs, ctr);
        return `<div class="cx-tab cx-div">
          ${article.tabs
            .map((tab, idx) =>
              this.buildUpTab(tab, idx == this.activeTabs[ctr], ctr),
            )
            .reduce(
              (tabs_articles, [tab, article]) =>
                tabs_articles[0].push(tab) &&
                tabs_articles[1].push(article) &&
                tabs_articles,
              [[], []],
            ) // make sure
            .reduce(
              (tabs_articles, tabsorarticles) =>
                tabs_articles.push(...tabsorarticles) && tabs_articles,
              [],
            ) // tabs html order in front of articles (for a11y tab focus order)
            .join("")}
        </div>`;
      }

      return "";
    },
    injectStyles(article, styles = "", root = false) {
      if (typeof article != "object") return;
      if (typeof article.style == "string" && article.style.length > 0) {
        styles += article.style;
      }

      if (Array.isArray(article.sections)) {
        article.sections.forEach(
          (section) => (styles += this.injectStyles(section, styles)),
        );
      }

      if (Array.isArray(article.tabs)) {
        article.tabs.forEach(
          (tab) => (styles += this.injectStyles(tab, styles)),
        );
      }

      if (root && styles.length > 0) {
        if (this.$ssrContext) {
          this.$ssrContext.articlePresetStyle += `<style id="${
            this.tmpID
          }" type="text/css">${styles}</style>`;
        } else {
          let sheet = document.createElement("style");
          sheet.id = this.tmpID;
          sheet.type = "text/css";
          sheet.innerHTML = styles;
          document.head.appendChild(sheet);
        }

        return;
      }

      return styles;
    },
    enjectStyles() {
      let sheetToEnject = document.getElementById(this.tmpID);
      if (this.tmpID && sheetToEnject) {
        document.head.removeChild(sheetToEnject);
      }
    },

    injectScripts(article) {
      if (typeof article != "object") return;
      if (typeof article.script == "string" && article.script.length > 0) {
        let inject = null;
        let enject = null;
        try {
          [inject, enject] = Function(
            "content",
            "config",
            "injectFunc",
            "enjectFunc",
            `"use strict"; 
              ${article.script}; 
              return [injectFunc, enjectFunc];`,
          ).call(this.context, {
            show: this.activeContent,
            hide: this.hideContent,
            isShow: this.isContentShow,
          });
        } catch (e) {
          console.error(e);
        }

        typeof inject == "function" && this.runScript(inject);
        typeof enject == "function" && this.enjectScripts.push(enject);
      }

      if (Array.isArray(article.sections)) {
        article.sections.forEach((section) => this.injectScripts(section));
      }

      if (Array.isArray(article.tabs)) {
        article.tabs.forEach((tab) => this.injectScripts(tab));
      }
    },
    runEnjectScripts() {
      this.enjectScripts &&
        this.enjectScripts.reverse().forEach((f) => this.runScript(f));
    },
    runScript(f) {
      try {
        f.call(this.context);
      } catch (e) {
        console.error(e);
      }
    },
  },
};
</script>

<style>
.cx-tab.cx-div
  input[type="radio"]:checked
  + label
  ~ article.tab-content-article {
  display: none;
}

/* Article tabs: allow multi-line labels (no ellipsis). */
.cx-tab.cx-div > label {
  height: auto;
}
.cx-tab.cx-div > label > span {
  white-space: normal;
  overflow: visible;
  text-overflow: clip;
  overflow-wrap: break-word;
  word-break: break-word;
  hyphens: auto;
}
</style>
